import type { SurveysRespondentStrategyInput } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface Props {
  strategy: SurveysRespondentStrategyInput
  onChange: (selection: EmployeeSelectorV2MultiSelectState) => void
}

export function EmployeesStrategy({ strategy, onChange }: Props) {
  // Get initial IDs from strategy.arguments for edit forms
  const initialIds = (strategy.arguments ?? []).filter(
    (id): id is number => id !== null && id !== undefined
  )

  return (
    <EmployeeSelectorV2
      multiple
      value={initialIds.length > 0 ? initialIds : undefined}
      label={i18n.t('surveys.configuration.participants.employees_label')}
      onChange={onChange}
      options={{ hideSearchIcon: true }}
    />
  )
}
